import LineChart from '../../charts/lineChart'
import ApiService from '../../../../../../services/ApiService'

export default {
  props: {
    filterProp: Object,
  },
  components: {
    LineChart,
  },
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      correntiveXPreventive: undefined,
      page: 1,
      showChart: true,
      totalPages: 1,
      pageSize: 7,
      percent: 0,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      correntiveXPreventiveChartData: {},
      corrective: [],
      preventive: [],
      labels: [],
      total: 0,
      data: {
        dataByMonth: [],
      },
    }
  },
  async created() {
    this.listcorrentiveXPreventive()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `preventiveXCorretive_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/preventiveXCorretive', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listcorrentiveXPreventive() {
      await this.apiService
        .post('reports/preventiveCorrective', this.filterProp)
        .then((response) => {
          this.data = response.content
          this.total = this.data.totalCorrective + this.data.totalPreventive
          this.fillcorrentiveXPreventiveChartData()
        })
        .catch((err) => {})
    },
    fillcorrentiveXPreventiveChartData() {
      this.correntiveXPreventiveChartData = {
        labels: this.data.dataByMonth.map((x) => x.month),
        datasets: [
          {
            label: this.$t('Corretiva'),
            data: this.data.dataByMonth.map((x) => x.totalCorrective),
            backgroundColor: 'rgba(26,131,194,0.75)',
            borderColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            tension: 0.2,
          },
          {
            label: this.$t('Preventiva'),
            data: this.data.dataByMonth.map((x) => x.totalPreventive),
            backgroundColor: 'rgba(228,150,28,0.69)',
            borderColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            tension: 0.2,
          },
        ],
      }
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listcorrentiveXPreventive()
    },
  },
}
